import styled from 'styled-components';
import { Body1Styles } from '../typography';
import { getThemeProp, getSizeBy, getColorShade, getColor } from '../../../src/styled/utils';
export const Wrapper = styled.li `
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: ${getSizeBy(5)} 1fr ${getSizeBy(5)};
  height: ${getSizeBy(11)};
  margin: 0 ${getSizeBy(6)} 0 ${getSizeBy(5)};
  background-color: ${getColor('surface')};
  border-radius: ${getThemeProp('borderRadius')}px;
  outline: none;
  cursor: pointer;
`;
export const TextWrapper = styled.span `
  margin-left: ${getSizeBy(5)};
  padding: ${getSizeBy(3)} 0;
  overflow: hidden;
  color: ${({ subsection, selected }) => {
    if (selected)
        return getColor('primary');
    return subsection
        ? getColorShade('onSurface', 'mediumEmphasis')
        : getColorShade('onSurface', 'lowEmphasis');
}};
  ${Body1Styles};
  white-space: nowrap;
  text-overflow: ellipsis;
  box-shadow: inset 0 -0.5px 0 ${getColorShade('onSurface', 'outline')};

  &:hover {
    color: ${getColorShade('onSurface', 'highEmphasis')};
  }

  &:active {
    color: ${getColor('primary')};
  }
`;
export const PrependWrapper = styled.div `
  display: flex;
  flex-direction: column;
  grid-column: 1 / 2;
  justify-content: center;

  & svg {
    text-align: center;
    transform: ${({ isOpen, isCollapsible }) => isCollapsible && isOpen && 'rotate(90deg)'};
    transition: transform 500ms ease-in-out;
  }
`;
export const AppendWrapper = styled.span `
  display: flex;
  flex-direction: column;
  grid-column: 3 / 4;
  justify-content: center;
  box-shadow: inset 0 -0.5px 0 ${getColorShade('onSurface', 'outline')};
`;
